const users = {
  users: {
    pageHeader: 'Użytkownicy',
    addNewUser: '+ Dodaj nowego użytkownika',
    name: 'Imię i nazwisko',
    role: 'Rola',
    company: 'Firma',
    status: 'Status',
    noUser: '** Brak dostępnych użytkowników **',
    emailMatch: 'Wprowadź ponownie tę samą wartość.',
    validEmail: 'Wprowadź prawidłowy adres e-mail.',
    fieldRequired: 'To pole jest wymagane.',
    userFormHeader: 'Dodaj nowych użytkowników',
    userProfile: 'Profil użytkownika',
    defaultEmailHelpText: 'Na ten adres zostanie wysłana wiadomość e-mail z procedurą logowania.',
    active: 'Aktywny',
    email: 'E-mail',
    confirmEmail: 'Potwierdź adres e-mail',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phoneNumber: 'Numer telefonu',
    preferredLocale: 'Preferowane ustawienia regionalne',
    units: 'Jednostki',
    addUser: 'Dodaj użytkownika',
    updateUser: 'Zaktualizuj użytkownika',
    supportTechnician: 'Pomoc techniczna',
    profileAdministrator: 'Administrator profilu',
    profileApprover: 'Osoba zatwierdzająca profil',
    administrator: 'Administrator',
    user: 'Użytkownik',
    viewOnly: 'Tylko wyświetlanie',
    demonstration: 'Pokaz',
    errorMessageLengthPhone: 'Dozwolone jest maksymalnie 50 znaków',
    all: 'Wszystkie',
    inactive: 'Nieaktywne',
    termsAndServices: 'Jedynie właściciel systemu może zapewnić dostęp do swojej instalacji w danej lokalizacji. Bez pisemnej zgody właściciela systemu instalatorzy nie mogą zapewniać dostępu do lokalizacji innym firmom ani nie mogą zapewniać takiego dostępu użytkownikom niebędącym pracownikami ich firmy. Potwierdzam zapoznanie się i akceptację %{termsService} Enphase oraz zapoznanie się z %{privacyPolicy} Enphase. Przyjmuję do wiadomości, że naruszenie tych warunków może skutkować zawieszeniem lub zamknięciem mojego konta Enlighten.',
    privacyPolicy: 'Polityką prywatności',
    termsService: 'Warunków świadczenia usług',
  }
};

export default users;
